
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    export class ModellingViewColumnDialog extends SiteEntityDialog<ModellingViewColumnRow, any> {
        protected getFormKey() { return ModellingViewColumnForm.formKey; }
        protected getIdProperty() { return ModellingViewColumnRow.idProperty; }
        protected getLocalTextPrefix() { return ModellingViewColumnRow.localTextPrefix; }
        protected getNameProperty() { return ModellingViewColumnRow.nameProperty; }
        protected getService() { return ModellingViewColumnService.baseUrl; }

        protected form = new ModellingViewColumnForm(this.idPrefix);

    }
}